"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const sso_config_service_1 = require("../../authentication/services/sso-config.service");
const i0 = require("@angular/core");
const i1 = require("../../authentication/services/sso-config.service");
const i2 = require("@angular/common");
const i3 = require("../../common/components/dnaR-checkbox/dnaR-checkbox.component");
function SsoConfigComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function SsoConfigComponent_ng_container_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.editSSOConfig(); });
    i0.ɵɵtext(2, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function SsoConfigComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0, 13);
    i0.ɵɵelementStart(1, "button", 14);
    i0.ɵɵlistener("click", function SsoConfigComponent_ng_container_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r7 = i0.ɵɵnextContext(); return ctx_r7.cancel(); });
    i0.ɵɵtext(2, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 15);
    i0.ɵɵlistener("click", function SsoConfigComponent_ng_container_6_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r8); const ctx_r9 = i0.ɵɵnextContext(); return ctx_r9.saveChanges(); });
    i0.ɵɵtext(4, "Save");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function SsoConfigComponent_td_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelement(1, "dnaR-checkbox", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r2.ssoConfig && ctx_r2.ssoConfig.enableSSO ? true : false)("isDisabled", true);
} }
function SsoConfigComponent_td_11_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "dnaR-checkbox", 17);
    i0.ɵɵlistener("onChecked", function SsoConfigComponent_td_11_Template_dnaR_checkbox_onChecked_1_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r10 = i0.ɵɵnextContext(); return ctx_r10.onToggleSSO($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isChecked", ctx_r3.isSSOEnabled);
} }
function SsoConfigComponent_div_19_tr_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const user_r13 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(user_r13.firstName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(user_r13.lastName);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(user_r13.isOnboarded ? "Yes" : "No");
} }
function SsoConfigComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵelementStart(1, "div", 9);
    i0.ɵɵelementStart(2, "table", 19);
    i0.ɵɵelementStart(3, "thead");
    i0.ɵɵelementStart(4, "tr");
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Onboarded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "tbody");
    i0.ɵɵtemplate(12, SsoConfigComponent_div_19_tr_12_Template, 7, 3, "tr", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(12);
    i0.ɵɵproperty("ngForOf", ctx_r4.users);
} }
class SsoConfigComponent {
    constructor(ssoService, cdr) {
        this.ssoService = ssoService;
        this.cdr = cdr;
        this.title = "SSO onfiguration";
        this.isViewMode = true;
        this.isLoading = false;
        this.ssoConfig = { enableSSO: false };
        this.isSSOEnabled = false;
        this.ssoProviders = [];
        this.users = [];
    }
    ngOnInit() {
        this.loadSsoStatus();
        this.loadUsers();
    }
    loadSsoStatus() {
        this.isLoading = true;
        this.ssoService.getOrganisationSsoStatus()
            .then((data) => {
            console.log("SSO status from API:", data);
            const status = data && data.isSsoEnabled === true;
            this.ssoConfig = { enableSSO: status };
            this.isSSOEnabled = status;
            this.isLoading = false;
            this.cdr.detectChanges();
        })
            .catch((err) => {
            console.error("Failed to fetch SSO status", err);
            this.isLoading = false;
        });
    }
    editSSOConfig() {
        this.isViewMode = false;
    }
    cancel() {
        this.isViewMode = true;
        this.loadSsoStatus();
    }
    saveChanges() {
        this.isLoading = true;
        this.ssoService.setOrganisationSsoStatus(this.isSSOEnabled)
            .then(() => {
            return Promise.all([this.loadSsoStatus(), this.loadUsers()]);
        })
            .then(() => {
            this.isViewMode = true;
            this.cdr.detectChanges();
        })
            .catch((err) => {
            console.error("Failed to save SSO setting", err);
            this.isLoading = false;
        });
    }
    onToggleSSO(event) {
        this.isSSOEnabled = event;
    }
    loadUsers() {
        this.ssoService.getOrganisationUsers()
            .then((data) => {
            this.users = data || [];
            this.cdr.detectChanges();
        })
            .catch((err) => {
            console.error("Failed to load users", err);
        });
    }
}
exports.SsoConfigComponent = SsoConfigComponent;
SsoConfigComponent.ɵfac = function SsoConfigComponent_Factory(t) { return new (t || SsoConfigComponent)(i0.ɵɵdirectiveInject(i1.OrganisationSsoService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
SsoConfigComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SsoConfigComponent, selectors: [["app-sso-config"]], decls: 20, vars: 5, consts: [[1, "col-xs-10", "col-xs-offset-1"], [1, "row", "feature-flags-header"], [1, "create-new-btn", "pull-right", "margin-top-20"], [4, "ngIf"], ["class", "edit-mode-buttons-container", 4, "ngIf"], [1, "table"], [1, "col-xs-12", "flags-row"], ["nav-publisher", "customerCare", 1, "clinical-integration"], [1, "row"], [1, "col-xs-12"], [1, "page-header"], ["class", "row table-section", 4, "ngIf"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "pull-right", 3, "click"], [1, "edit-mode-buttons-container"], ["type", "button", 1, "btn", "btn-warning", "btn-lg", "cancel-button", 3, "click"], ["type", "button", 1, "btn", "btn-primary", "btn-lg", "save-button", 2, "margin-left", "8px", 3, "click"], [3, "isChecked", "isDisabled"], [3, "isChecked", "onChecked"], [1, "row", "table-section"], [1, "default-table", "table", "table-bordered"], [4, "ngFor", "ngForOf"]], template: function SsoConfigComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "h1");
        i0.ɵɵtext(3, "SSO configuration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 2);
        i0.ɵɵtemplate(5, SsoConfigComponent_ng_container_5_Template, 3, 0, "ng-container", 3);
        i0.ɵɵtemplate(6, SsoConfigComponent_ng_container_6_Template, 5, 0, "ng-container", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "table", 5);
        i0.ɵɵelement(8, "th");
        i0.ɵɵelementStart(9, "tr", 6);
        i0.ɵɵtemplate(10, SsoConfigComponent_td_10_Template, 2, 2, "td", 3);
        i0.ɵɵtemplate(11, SsoConfigComponent_td_11_Template, 2, 1, "td", 3);
        i0.ɵɵelementStart(12, "td");
        i0.ɵɵtext(13, "Enable SSO configuration");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(14, "div", 7);
        i0.ɵɵelementStart(15, "div", 8);
        i0.ɵɵelementStart(16, "div", 9);
        i0.ɵɵelementStart(17, "h3", 10);
        i0.ɵɵtext(18, "Organisation Users");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(19, SsoConfigComponent_div_19_Template, 13, 1, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isViewMode);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isViewMode);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.users && ctx.users.length);
    } }, directives: [i2.NgIf, i3.DnaRCheckbox, i2.NgForOf], encapsulation: 2 });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SsoConfigComponent, [{
        type: core_1.Component,
        args: [{
                selector: "app-sso-config",
                templateUrl: "./sso-config.component.html"
            }]
    }], function () { return [{ type: i1.OrganisationSsoService }, { type: i0.ChangeDetectorRef }]; }, null); })();
